import { render } from "./ExhibitorDetailDialog.vue?vue&type=template&id=435454f7&scoped=true&ts=true"
import script from "./ExhibitorDetailDialog.vue?vue&type=script&lang=ts"
export * from "./ExhibitorDetailDialog.vue?vue&type=script&lang=ts"

import "./ExhibitorDetailDialog.vue?vue&type=style&index=0&id=435454f7&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\program-list-inh26\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435454f7"]])

export default __exports__